import {
  BottomNavigation as MuiBottomNavigation,
  Box,
  Slide,
  useTheme,
} from "@mui/material"
import qs from "qs"
import { useNavigate } from "react-router-dom"
import { useTranslation } from "providers/i18n"
import { IMenuConfig } from "providers/ui/hooks/useAppNavigation/utils"
import { NavigationLink } from "components/navigation/NavigationLink"
import { ExtendedBottomNavigationAction } from "./ExtendedBottomNavigationAction"
import { useCallback } from "react"

interface INavigationProps {
  value: string
  navigations: IMenuConfig[]
  show?: boolean
}

export const Navigation = ({
  value,
  navigations,
  show = true,
}: INavigationProps) => {
  const { t } = useTranslation()
  const navigate = useNavigate()

  const theme = useTheme()
  const styleOverrides =
    theme.components[`AppKioskNavigation`]?.styleOverrides || {}
  const { root, menuButton, navigationContainer } = styleOverrides

  const handleClickNavigationButton = useCallback(
    (event: React.MouseEvent, navigationPath: string) => {
      event.preventDefault()

      navigate(navigationPath)
    },
    [navigate]
  )

  return (
    <Slide direction="up" appear={false} mountOnEnter unmountOnExit in={show}>
      <Box sx={root}>
        <MuiBottomNavigation value={value} showLabels sx={navigationContainer}>
          {navigations.map(
            ({
              to,
              label,
              icon,
              active_icon,
              qs: queryString,
              disabled = false,
            }) => {
              const activeIcon = active_icon || icon
              const isSelected = to === value
              const navigationPath = `${to}?${qs.stringify(queryString)}`
              const navigationRef = to.slice(1)
              return (
                <ExtendedBottomNavigationAction
                  sx={menuButton}
                  component={NavigationLink}
                  key={to}
                  label={t([`navigation.${label}`, label])}
                  value={to}
                  icon={isSelected ? activeIcon : icon}
                  disabled={disabled}
                  backSideProps={{
                    children: icon,
                  }}
                  onClick={(e) =>
                    handleClickNavigationButton(e, navigationPath)
                  }
                  className={navigationRef}
                />
              )
            }
          )}
        </MuiBottomNavigation>
      </Box>
    </Slide>
  )
}
